<div [ngClass]="{ 'embedded-content': contentStyle === 'embedded' }">
    <adapt-implementation-kit-content [articleId]="articleId"
                                      [loadOnEmit]="loadOnEmit"
                                      (articleName)="onArticleNameUpdated($event)"
                                      (contentLoaded)="onContentLoaded()"> </adapt-implementation-kit-content>
</div>
